import { render, staticRenderFns } from "./FundsDetails.vue?vue&type=template&id=06624c30&scoped=true&"
import script from "./FundsDetails.vue?vue&type=script&lang=ts&"
export * from "./FundsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FundsDetails.vue?vue&type=style&index=0&id=06624c30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06624c30",
  null
  
)

export default component.exports